import { Box } from '@mui/material';
import { ReactNode } from 'react';

export const ActionsContainer = ({ children }: { children: ReactNode }) => {
  return <Box sx={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'nowrap', gap: 2 }}>{children}</Box>;
};
